export default __webpack_public_path__ + "static/media/checked.443569d2.svg";